import React from "react";

import { Col, FormLabel, Row, Table } from "react-bootstrap";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";

import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";

import {
  BankAccountBalanceHistoryTrackCriteriaBean,
  BankAccountBalanceHistoryTrackPrintRequest,
  RestPageListBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
class BankAccountBalance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Bank Balance History Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,

      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new BankAccountBalanceHistoryTrackCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,

      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      inquiryData: null,
      bankCodes: [],

      bankPageListForAutoCompleteList: new Array(),
      showAutoCompleteBankList: true,
      isDisableFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowExitButton: true,
      order: "asc",
      sortField: "",
    };
    this.bankCodeRef = React.createRef();
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let bankCodes = attribute_cache.bankAccounts;
    if (bankCodes != null || bankCodes != undefined) {
      bankCodes.map((attr) => {
        this.state.bankCodes.push(attr);
      });
    }
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let bankLookupHandler = new GenericAttributeLookupHandler(
      this.state.bankCodes,
      "Bank Account"
    );
    this.setState({ bankLookupHandler: bankLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing..",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;

    this.loadBankBalanceInquiryList(criteria);
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  loadBankBalanceInquiryList = (criteria) => {
    if (
      SecurityAccessManager.BankAccountBalanceHistoryTrackInquiry_IsAccessible()
    ) {
      ReportService.inquireBankAccountBalanceHistoryTrack(
        criteria,
        this.loadBankBalancePageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadBankBalancePageResponse = (response) => {
    if (response.data != null && response.data.result) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.result.historyTracks)) {
        resultList = response.data.result.historyTracks;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        inquiryDataList: resultList,
        isCollapsible_open: false,
        isShowResetButton: true,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;

    let listRequest = new BankAccountBalanceHistoryTrackPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;

    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.BankAccountBalanceHistoryTrackInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateBankAccountBalanceHistoryTrackPrintReport(
          listRequest,
          this.generateBankAccountBalancePageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "PDF Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.BankAccountBalanceHistoryTrackInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateBankAccountBalanceHistoryTrackPrintReport(
          listRequest,
          this.generateBankAccountBalancePageResponseForExcel,
          this.errorCallBack
        );
      } else {
        let errMsg = "PDF Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateBankAccountBalancePageResponse = (response) => {
     this.showErrorMessage(response.data);
     if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
    let reportFilePath = response.data.reportResult.reportFileID;
    window.open(this.report_url + reportFilePath);
      }
    }
  };
    generateBankAccountBalancePageResponseForExcel = (response) => {
     this.showErrorMessage(response.data);
     if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
    let reportFilePath = response.data.reportResult.reportFileID;
    // window.open(this.report_url + reportFilePath);
     let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
  };


  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new BankAccountBalanceHistoryTrackCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    this.setState({ criteria: tempCriteria });
  };
  resetInquiry = () => {
    let tempCriteria = new BankAccountBalanceHistoryTrackCriteriaBean();
    tempCriteria.companyCode = this.companyCode;

    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  transactionTypeConvertor = (transactionType) => {
    if (transactionType == 1) {
      return "Deposit_Apprvl";
    } else if (transactionType == 2) {
      return "Deposit_Update";
    } else if (transactionType == 3) {
      return "Bank_Adj_Apprvl";
    } else if (transactionType == 4) {
      return "Bank_Adj_Cancel";
    } else if (transactionType == 5) {
      return "Check_Transact_Apprvl";
    } else if (transactionType == 6) {
      return "Check_Transact_Cancel";
    } else if (transactionType == 7) {
      return "Deposit_Cancel";
    }

    return "";
  };

  bankCodeOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.showAutoCompleteBankList = true;

    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteBankList;

    if (isEmpty(bankCode)) {
      this.state.showAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBankList;
      let criteria = this.state.criteria;
      criteria.bankCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteBankList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteBankList: suggestion,
      });
    } else if (showAutoCompleteList === true && bankCode !== "") {
      this.readBankBySearchString(bankCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });

    this.readBank(bankCode);
  };

  readBank = (bankCode) => {
    let bankBean = null;
    //  let bankList = [];
    this.state.bankCodes.map((ln) => {
      if (ln.code === bankCode) {
        bankBean = ln;
      }
    });
    if (!isEmpty(bankBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.bankCode = bankBean.code;
      this.state.showAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBankList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteBankList: showAutoCompleteList,
      });
    }
    // bankList.push(bankBean);
    this.setState({ bankList: bankBean });
  };

  readBankBySearchString = (searchString) => {
    let bankData = this.state.bankCodes;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((sp) => {
        let bankBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };

  bankEnterKeyEventHandler = (e) => {
    let bankCode = e.target.value;
    this.readBank(bankCode);
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteBankList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteBankList: showAutoCompleteList });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let isLoading = this.state.isLoading;
    let inquiryData = this.state.inquiryData;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
        />

        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          bankLookupHandler={this.state.bankLookupHandler}
          bankCodeRef={this.bankCodeRef}
          bankEnterKeyEventHandler={this.bankEnterKeyEventHandler}
          displayAutoCompleteBankList={this.displayAutoCompleteBankList}
          bankCodeOnChange={this.bankCodeOnChange}
        />

        {/*this.state.isInquiryDatasFound ? (
	        <BaseInquiryPageListToolBar
	        // currentPage={pageList.currentPage}
	        //totalPages={totalPages}
	        //isLoadFirstButton={this.state.isLoadFirstButton}
	        //isLoadLastButton={this.state.isLoadLastButton}
	        //isLoadPreviousButton={this.state.isLoadPreviousButton}
	        //isLoadNextButton={this.state.isLoadNextButton}
	        //loadFirst={this.loadFirst}
	        //loadLast={this.loadLast}
	        //loadNext={this.loadNext}
	        //loadPrevious={this.loadPrevious}
	        />
	     
	      ) : null}       
	        {isLoading ? <Loader /> : null*/}

        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              {" "}
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "bankAccountNumber")
                    }
                  >
                    BankA/C
                    {this.state.order === "desc" &&
                    this.state.sortField === "bankAccountNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "openingBalanceAmount")
                    }
                  >
                    OpeningBalance
                    {this.state.order === "desc" &&
                    this.state.sortField === "openingBalanceAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "transactionAmount")
                    }
                  >
                    Transaction Amt
                    {this.state.order === "desc" &&
                    this.state.sortField === "transactionAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "closingBalanceAmount")
                    }
                  >
                    ClosingBalance
                    {this.state.order === "desc" &&
                    this.state.sortField === "closingBalanceAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "currencyCode")}
                  >
                    CurrencyCode
                    {this.state.order === "desc" &&
                    this.state.sortField === "currencyCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "exchangeRate")}
                  >
                    ExchangeRate
                    {this.state.order === "desc" &&
                    this.state.sortField === "exchangeRate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "transactionType")
                    }
                  >
                    Transaction Type
                    {this.state.order === "desc" &&
                    this.state.sortField === "transactionType" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "sourceTransactionAmount")
                    }
                  >
                    Source Trans Amt
                    {this.state.order === "desc" &&
                    this.state.sortField === "sourceTransactionAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "sourceCurrencyCode")
                    }
                  >
                    Source Currency Code
                    {this.state.order === "desc" &&
                    this.state.sortField === "sourceCurrencyCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "historyDate")}
                  >
                    HistoryDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "historyDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "remarks")}>
                    Remarks
                    {this.state.order === "desc" &&
                    this.state.sortField === "remarks" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "balanceHistoryTrackNumber")
                    }
                  >
                    Balance History Track
                    {this.state.order === "desc" &&
                    this.state.sortField === "balanceHistoryTrackNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              {inquiryDataList != null && (
                <tbody>
                  {inquiryDataList.map((inquiryInfo, index) => (
                    <tr key={index}>
                      <td>{inquiryInfo.bankAccountNumber}</td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(
                          inquiryInfo.openingBalanceAmount
                        )}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(inquiryInfo.transactionAmount)}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(
                          inquiryInfo.closingBalanceAmount
                        )}
                      </td>
                      <td>{inquiryInfo.currencyCode}</td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(inquiryInfo.exchangeRate)}
                      </td>
                      <td>
                        {this.transactionTypeConvertor(
                          inquiryInfo.transactionType
                        )}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(
                          inquiryInfo.sourceTransactionAmount
                        )}
                      </td>
                      <td>{inquiryInfo.sourceCurrencyCode}</td>
                      <td>{inquiryInfo.historyDate}</td>
                      <td>{inquiryInfo.remarks}</td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(
                          inquiryInfo.balanceHistoryTrackNumber
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  // const [show, setShow] = useState(false);
  // const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    // handleButton();
    props.loadPage(1);
  };
  const bankCodeOnChange = (e) => props.bankCodeOnChange(e);
  const bankEnterKeyEventHandler = (e) => {
    props.bankEnterKeyEventHandler(e);
  };

  const displayAutoCompleteBankList = () => {
    props.displayAutoCompleteBankList();
  };

  let criteria = props.criteria;
  let bankLookupHandler = props.bankLookupHandler;
  // let bankCodeRef = React.createRef();
  const bankCodeRef = props.bankCodeRef;
  // if (bankCodeRef.current != null) {
  //   bankCodeRef.current.focus();
  // }
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>BankCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={bankCodeRef}
            name="bankCode"
            onChange={bankCodeOnChange}
            value={criteria.bankCode}
            lookupRequired={true}
            lookupHandler={bankLookupHandler}
            enterKeyEventHandler={bankEnterKeyEventHandler}
            autoCompleteListData={props.bankPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteBankList}
            showAutoCompleteList={props.showAutoCompleteBankList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>History Date From </FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="historyDateFrom"
            value={criteria.historyDateFrom}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>History Date To</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="historyDateTo"
            onChange={onChange}
            value={criteria.historyDateTo}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
    </div>
  );
}
function BankAccountBalanceHistoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <BankAccountBalance {...props} name="" /> <br />
    </div>
  );
}

export default BankAccountBalanceHistoryInquiry;
